import React, {useCallback, useContext, useEffect, useState} from 'react';
import {
    DownOutlined, TranslationOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import {Button, Dropdown, Space} from 'antd';
import {AuthContext} from "../../provider/authentication/keycloak.authentication.provider";
import {observer} from "mobx-react";
import {StoreContext} from "../../store.context";
import {Translate} from "../util/translation.util";

const HeaderMenu: React.FC<any> = observer(() => {
    const { appStore: {
        authStore: { profile, setMyAccount, account },
        locale,
        setLocale,
        toggleTranslatorMode,
        getLocales,
        accessStore: { hasAccess },
        moduleStore: { userStore: { myAccount, setActiveRole }},
        getCountries,
    }} = useContext(StoreContext);

    const [locales, setLocales] = useState<MenuProps['items']>([])
    const [roles, setRoles] = useState<MenuProps['items']>([])

    const authContext = useContext(AuthContext);
    const ButtonGroup = Button.Group;

    const changeLocale = useCallback(async (locale: string) => {
        setLocale(locale);
        document.location.reload();
    }, [setLocale]);

    useEffect(() => {
        let activeLocales: MenuProps['items'] = [];
        getLocales().then(({ data }) => {
            for (let locale in data) {
                activeLocales?.push({
                    label: <Translate message={data[locale].name} /> ,
                    key: data[locale].id,
                    onClick: () => {
                        changeLocale(data[locale].id)
                    }
                })
            }

            hasAccess({
                routeName: 'translator_invalidate_cache',
                attributes: [],
            }).then(() => {
                activeLocales?.push({
                    label: <Translate message={`global.button.translator_mode`} /> ,
                    key: '10',
                    icon: <TranslationOutlined />,
                    onClick: () => {
                        toggleTranslatorMode()
                    }
                })
            })
            .catch(() => {})
            .finally(() => {
                setLocales(activeLocales);
            })
        });
        getCountries();
    }, [changeLocale, getCountries, getLocales, hasAccess, toggleTranslatorMode])

    useEffect(() => {
        myAccount().then(data => {
            setMyAccount(data);
            setRoles(data.userRoles.map(role => ({
                label: role.name,
                key: role.id,
                onClick: () => {
                    setActiveRole({ role: role.id }).then(() => {
                        window.location.href = '/'
                    })
                }
            })))
        })
    }, [myAccount, setMyAccount, setActiveRole])

    return (
        <ButtonGroup style={{ float: 'right', margin: '16px' }}>
            {
                (roles && roles?.length > 1) && (
                    <Dropdown menu={{ items: roles }}>
                        <Button type={`primary`}>
                            <Space>
                                { account?.activeRole?.name }
                                <DownOutlined />
                            </Space>
                        </Button>
                    </Dropdown>
                )
            }
            <Button type={`primary`} onClick={() => {
                authContext.logout();
            }}>
                <Translate message={`global.button.logout`} /> ({ profile?.username })
            </Button>
            <Dropdown menu={{ items: locales }}>
                <Button type={`primary`}>
                    <Space>
                        { locale }
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
        </ButtonGroup>
    );
})

export default HeaderMenu;